'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var Checkbox = (_temp = _class = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox(props) {
    _classCallCheck(this, Checkbox);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Checkbox).call(this, props));

    _this._changeHandle = function (e) {
      var checked = e.target.checked;
      _this.setState({ checked: checked });
      _this.props.onChange(e);
    };

    _this._clickHandle = function (e) {
      _this.props.onClick && _this.props.onClick(e);
    };

    _this._focusHandle = function (e) {
      _this.props.onFocus && _this.props.onFocus(e);
    };

    _this._blurHandle = function (e) {
      _this.props.onBlur && _this.props.onBlur(e);
    };

    _this.state = {
      checked: props.checked,
      focus: false
    };
    return _this;
  }

  _createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      //只在这个时候来初始值
      if (this.props.defaultChecked && !this.state.checked) {
        var checked = this.props.defaultChecked;
        this.setState({ checked: checked, focus: false });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ('checked' in nextProps) {
        this.setState({
          checked: nextProps.checked
        });
      }
    }

    // 当值改变时触发, 此时也是告知外层组件值变化的时机


    // 当点击时触发


    // 当获得焦点时触发


    // 当失去焦点时触发

  }, {
    key: 'render',
    value: function render() {
      var _classNames, _classNames2;

      var props = _extends({}, this.props);
      var checked = this.state.checked;

      if (typeof checked === 'number') {
        checked = checked ? true : false;
      }

      var className = props.className;
      var style = props.style;
      var name = props.name;
      var type = props.type;
      var size = props.size;
      var disabled = props.disabled;
      var indeterminate = props.indeterminate;
      var label = props.label;
      var domProps = props.domProps;

      var prefixCls = props.prefixCls + "-" + type;
      var children = label || props.children;

      var wraperClassName = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, '' + prefixCls, true), _defineProperty(_classNames, prefixCls + '-sm', size === 'small'), _defineProperty(_classNames, prefixCls + '-disabled', disabled), _classNames));
      var checkboxClassName = (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-checked', checked), _defineProperty(_classNames2, prefixCls + '-indeterminate', indeterminate), _classNames2));
      return _react2.default.createElement(
        'label',
        { className: wraperClassName, style: style },
        _react2.default.createElement(
          'span',
          { className: checkboxClassName },
          _react2.default.createElement('span', { className: prefixCls + '-inner' }),
          _react2.default.createElement('input', _extends({}, domProps, {
            name: name,
            type: type,
            disabled: !!disabled,
            checked: checked || false,
            className: prefixCls + '-input',
            onClick: this._clickHandle,
            onChange: this._changeHandle,
            onFocus: this._focusHandle,
            onBlur: this._blurHandle
          }))
        ),
        children !== undefined ? _react2.default.createElement(
          'span',
          { className: prefixCls + '-label' },
          children
        ) : null
      );
    }
  }]);

  return Checkbox;
}(_react.Component), _class.propTypes = {
  prefixCls: _propTypes2.default.string,
  type: _propTypes2.default.string,
  name: _propTypes2.default.string,
  checked: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  defaultChecked: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  indeterminate: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'default']),
  label: _propTypes2.default.any,
  onChange: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  domProps: _propTypes2.default.object
}, _class.defaultProps = {
  prefixCls: 'mt', // 样式前缀
  type: 'checkbox', // 默认的类型, 可选值为 checkbox|radio
  disabled: false, // 是否被禁用
  defaultChecked: false, // 初始是否被选中
  indeterminate: false, // 只用来控制样式
  size: 'default', // 控件大小
  label: '', // 说明文字
  onChange: function onChange() {},
  // 变化时回调函数
  onClick: null, // 点击时的回调函数
  onFocus: null, // 获得焦点时的回调函数
  onBlur: null, // 失去焦点时的回调函数
  domProps: {} }, _temp);
exports.default = Checkbox;